import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { EmoticonReaction, EmoticonReactionDef } from '../emoticon-reactions/emoticon-reaction.type';
import { AsyncPipe, CommonModule } from '@angular/common';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { BehaviorSubject, combineLatest, debounceTime, map } from 'rxjs';
import { ReactionId } from '../../timeline-item.types';

@Component({
    selector: 'thread-emoticon-reactions',
    templateUrl: './thread-emoticon-reactions.component.html',
    styleUrls: ['./thread-emoticon-reactions.component.scss'],
    standalone: true,
    imports: [
            MatTooltipModule,
            TranslateModule,
            CommonModule,
            AsyncPipe,
            MatTooltipModule,
            OverlayModule,
        ],
        changeDetection: ChangeDetectionStrategy.OnPush
    })
    export class ThreadEmoticonReactionsComponent {
      
      // Subjects to manage overlay display
      buttonHovered = new BehaviorSubject(false);
      overlayHovered = new BehaviorSubject(false);
      isOpened$ = combineLatest([
        this.buttonHovered.pipe(debounceTime(100)),
        this.overlayHovered
      ]).pipe(
        map(([buttonHovered, overlayHovered]) => buttonHovered || overlayHovered)
      );
    
      overlayPositions: ConnectedPosition[] = [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        }, {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom'
        }
      ]
    
      @Input()
      value: EmoticonReaction;
    
      @Input()
      options: EmoticonReactionDef[];
      
      @Input()
      reactions: EmoticonReaction[];

      @Output()
      onReaction = new EventEmitter<ReactionId>();
    
      react(reaction?: ReactionId) {
        this.overlayHovered.next(false);
    
        if (reaction) {
          this.onReaction.next(reaction);
        }
      }
    }

